import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import { setToken } from "@/lib/auth";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      setToken(res.data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-theme min-h-screen bg-[#F8F9FA] flex items-center justify-center font-admin">
      <form onSubmit={onSubmit} className="w-full max-w-sm bg-white border border-[#E9ECEF] rounded-lg p-8 shadow-sm" data-testid="admin-login-form">
        <h1 className="text-2xl font-semibold mb-1">Admin sign in</h1>
        <p className="text-sm text-[#6C757D] mb-6">Sustainably Curated control panel.</p>
        <label className="block text-sm mb-2">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full h-10 px-3 border border-[#E9ECEF] rounded-md focus:outline-none focus:border-[#212529] mb-4"
          data-testid="admin-login-password-input"
        />
        <button type="submit" disabled={loading} className="w-full bg-[#212529] text-white rounded-md py-2 hover:bg-[#343A40] disabled:opacity-60" data-testid="admin-login-submit-button">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
